import { Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BuyerPurchaseService } from '../../comprar.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Review, SellerReview } from './_models/sellerReview';
import { NotificationService } from '../../../../_services/notification.service';
import { Globals } from '../../../../_models/globals';
import { ApiResponseModel } from '../../../../_models/apiResponseModel';

@Component({
    selector: 'app-resposta-avaliacao-modal', templateUrl: 'resposta-avaliacao-modal.component.html', styleUrls: ['resposta-avaliacao-modal.component.scss'],
    standalone: false
})
export class BuyerComprarRespostaAvaliacaoModalComponent
{
    @ViewChild('templateModalRespostaAvaliacao') template: TemplateRef<any>;
    isUsuarioCentral: boolean;
    modalRef: BsModalRef;
    sellerCompanyId: number;
    sellerReview: SellerReview;
    brandName: string;
    reviewsLoadQuantity: number = 5;

    constructor(private buyerVisaoGeralComprarService: BuyerPurchaseService, private globals: Globals, private notificationService: NotificationService, private modalService: BsModalService, private ngxLoader: NgxUiLoaderService) { }

    async close(): Promise<void> {
        this.modalRef.hide()
    }

    open(selectedOrder: { quotationId: number, sellerCompanyId: number, brandName: string }, isUsuarioCentral: boolean): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.sellerReview = null;
            this.modalRef = this.modalService.show(this.template, { class: 'custom-modal' });

            this.ngxLoader.startLoader('loader-reviews');

            this.buyerVisaoGeralComprarService.getResponseSellerReview(selectedOrder.quotationId, selectedOrder.sellerCompanyId).subscribe({
                next: (response: ApiResponseModel<{sellerReviewDetails: SellerReview}>) => {
                    this.ngxLoader.stopLoader('loader-reviews');

                    this.sellerReview = response.result.sellerReviewDetails;
                    this.sellerCompanyId = selectedOrder.sellerCompanyId;
                    this.isUsuarioCentral = isUsuarioCentral;
                    this.brandName = selectedOrder.brandName;
                },
                error: (response: any) => {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.area-respostas.modal-avaliacao.erro.abrir'))
                    this.ngxLoader.stopLoader('loader-reviews');
                    this.close();
                }
            })

            resolve(true);
        })
    }

    loadMoreSellerReviews() {
        this.ngxLoader.startLoader('loader-reviews');

        let pageNumber = this.sellerReview.reviews.length / this.reviewsLoadQuantity;

        if (pageNumber < 1)
            pageNumber = 1;

        this.buyerVisaoGeralComprarService.getSellerReviews(this.sellerCompanyId, pageNumber, this.reviewsLoadQuantity).subscribe({
            next: (response: ApiResponseModel<{sellerReview: Review[]}>) => {
                this.sellerReview.reviews.push(...response.result.sellerReview);
                this.ngxLoader.stopLoader('loader-reviews');
            },
            error: () => {
                this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.area-respostas.modal-avaliacao.erro.carregar-avaliacoes'))
                this.ngxLoader.stopLoader('loader-reviews');
            }
        })
    }
}
